import { render, staticRenderFns } from "./rule-set.vue?vue&type=template&id=252824ce&scoped=true&"
import script from "./rule-set.vue?vue&type=script&lang=js&"
export * from "./rule-set.vue?vue&type=script&lang=js&"
import style0 from "./rule-set.vue?vue&type=style&index=0&id=252824ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252824ce",
  null
  
)

export default component.exports